import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;
const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getDefaultMilestoneApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `getDefaultMilestone`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getTripsListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `trips`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitTripsAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `trips`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateTripsAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `trips/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripsEditApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `trips/get/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteTripsApi = async (id) => {
  try {
    const response = await axios.delete(apiUrl + `trips/delete/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const bulkDeleteTripsApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    const response = await axios.delete(apiUrl + `trips/bulkdelete`, {
      data,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripsViewApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `trips/view/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getActualWorkflowApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `trips/workflow/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getEstimateWorkflowApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `trips/est_workflow/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getAllocationHistoryApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `get_allocation_history/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVehicleDetailApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `vehicle/details/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getCustomerAutoCompleteApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + `customer/autosuggestion?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getFromAddressAutoCompleteApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + `stops/from_address?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getToAddressAutoCompleteApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + `stops/to_address?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getStopsApi = async (body) => {
  try {
    const response = await axios.post(apiUrl + `getstops`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getSortedStopsApi = async (body) => {
  try {
    const response = await axios.post(apiUrl + `sort_stops`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getStopsListApi = async (tripId) => {
  try {
    const response = await axios.get(apiUrl + `trips/stops/${tripId}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getStopProductListApi = async (stopId) => {
  try {
    const response = await axios.get(apiUrl + `stops/products/${stopId}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getDriverAutoCompleteApi = async (employeeIdQueryParam, term) => {
  try {
    const response = await axios.get(adminUrl + `get_driver?id=${employeeIdQueryParam}&term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateDriverAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `update_driver`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getNextMilestoneApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `mobile/get_next_milestone/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getSkippedMilestoneApi = async (tripId, stopId) => {
  try {
    const response = await axios.get(apiUrl + `trips/hold_status?trip_id=${tripId}&stop_id=${stopId}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getUpdateMilestoneApi = async (body) => {
  try {
    const response = await axios.post(apiUrl + `mobile/trip/update_milestone`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getUpdateSkippedMilestoneApi = async (tripId, body) => {
  try {
    const response = await axios.post(apiUrl + `trips/hold_status_update/` + tripId, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getProductDetailsApi = async (stopId) => {
  try {
    const response = await axios.get(apiUrl + `mobile/get_stop_products?stop_id=${stopId}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const productConfirmationApi = async (body) => {
  try {
    const response = await axios.post(apiUrl + `mobile/update_product_confirmation`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const paymentUpdateApi = async (body) => {
  try {
    const response = await axios.post(apiUrl + `mobile/update_payment`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const paymentUpdateImageApi = async (body) => {
  try {
    const response = await axios.put(apiUrl + `mobile/update_payment_image`, body, {
      headers: header,
    });
    console.log("Payment image update response:", response);
    return response;
  } catch (err) {
    console.error("Error updating payment images:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const addTripHistoryAttachmentsApi = async (tripHistoryId, body) => {
  try {
    const response = await axios.post(apiUrl + `mobile/trip_history/attachment/${tripHistoryId}`, body, {
      headers: header,
    });
    console.log("Trip history attachments response:", response);
    return response;
  } catch (err) {
    console.error("Error adding trip history attachments:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download Trip Template
export const downloadTripTemplateApi = async () => {
  try {
    const response = await axios.post(
      apiUrl + `template_download`,
      { type: "trip" },
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error downloading template:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download base64 file utility
export const downloadBase64File = (base64String, fileName) => {
  try {
    const base64Data = base64String.replace(/^data:.*,/, "");
    const binary = atob(base64Data);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the URL object to prevent memory leaks
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
